module.exports = __webpack_public_path__ + "dist/assets/browser-edge-new.e3ef3bbcd5cb23a5b9e10d26e4b40d24.png";